import React from 'react';
import { useStreamAuth } from '../../hooks/useStreamAuth';

const LogoutButton = ({ className = '', children = 'Log Out' }) => {
  const { logout, isAuthenticated, isLoading } = useStreamAuth();

  if (isLoading) {
    return (
      <button
        className={`px-4 py-2 bg-gray-600 text-white rounded opacity-50 cursor-not-allowed ${className}`}
        disabled
      >
        Loading...
      </button>
    );
  }

  if (!isAuthenticated) {
    return null;
  }

  return (
    <button
      className={`px-4 py-2 bg-red-600 hover:bg-red-700 text-white rounded transition-colors duration-200 ${className}`}
      onClick={() =>
        logout({
          logoutParams: {
            returnTo: window.location.origin,
          },
        })
      }
    >
      {children}
    </button>
  );
};

export default LogoutButton;
